import styled from "styled-components";

import { HttpLayout } from "src/organization/pages/project/environment/metrics/http/components";

export const TimelineHeight = 240;

export const Container = styled.div`
  height: ${TimelineHeight}px;
  overflow: hidden;

  .skeleton {
    height: ${TimelineHeight}px;
  }
`;

export const Layout = styled(HttpLayout)``;

export const OutOfRetentionRect = styled.rect`
  fill: var(--section-slate-color, var(--ice));
`;

export const OutOfRetentionText = styled.text`
  fill: var(--section-slate-fill, var(--slate));
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;
